module.exports = __webpack_public_path__ + "img/bannerai.8afbd0c7.png";